module.exports = __webpack_public_path__ + "img/hr-tree-07-b-leaves.279cbb13.png";